import { render, staticRenderFns } from "./ModuleElementChatbox.vue?vue&type=template&id=025cab7c&scoped=true&"
import script from "./ModuleElementChatbox.vue?vue&type=script&lang=js&"
export * from "./ModuleElementChatbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cab7c",
  null
  
)

export default component.exports